// Rows shown per page on admin list tables (RoomManagement, RoomTypeManagement).
export const ADMIN_ROWS_PER_PAGE = 10;
